export const SITE_DETAILS_SORT_BY = [
  'assigned_delivery_notes_count',
  'is_active',
  'signature_rate',
  'signed_delivery_notes_count',
  'site_name',
  'unsigned_delivery_notes_count',
] as const;

export const SITE_DETAILS_SIGNATURE_FILTER = [
  'all',
  'signed',
  'unsigned',
] as const;
